export function getUnixTimestamp(date?: Date) {
    if (!date) {
        return undefined;
    }
    try {
        return Math.round(date.getTime() / 1000);
    } catch {
        throw new Error('Invalid date');
    }
}
